import i18n from 'i18next'
const tonesObject = i18n.t('workflows.common.tones', {returnObjects: true}) as Record<
  string,
  string
>
const toneData = Object.values(tonesObject)

export default toneData
